import {memo} from "react";
import {Pie} from '@ant-design/charts';

const IndustryChart = memo(({data, customConfig = {}}) => {

    var config = {
        appendPadding: 10,
        data: data,
        angleField: 'percentage',
        colorField: 'industry',
        radius: 0.9,
        meta: {
            percentage: {
                alias: 'เปอร์เซ็นต์',
                formatter: (value) => `${value.toFixed(2)}%`
            }
        },
        label: {
            type: 'outer',
            content: (_ref) => `${_ref.industry} ${_ref.percentage.toFixed(2)}%`,
        },
        // legend: {
        //     layout: 'horizontal',
        //     position: 'bottom'
        // },
        interactions: [{ type: 'element-active' }],
    };
    return <Pie {...config} />;
})

export default IndustryChart;